var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58836 11.9039C6.58836 12.2169 6.31819 12.4707 5.98494 12.4707H0.755278C0.422025 12.4707 0.151855 12.2169 0.151855 11.9039V0.56685C0.151855 0.2538 0.422025 0 0.755278 0H5.98494C6.31819 0 6.58836 0.2538 6.58836 0.56685C6.58836 0.8799 6.31819 1.1337 5.98494 1.1337H1.3587V11.337H5.98494C6.31819 11.337 6.58836 11.5908 6.58836 11.9039ZM8.77657 3.18914C9.01222 2.9678 9.39435 2.96784 9.62992 3.18918L12.4458 5.83455C12.6815 6.05592 12.6815 6.41485 12.4458 6.63619L9.62992 9.28141C9.51214 9.3921 9.3577 9.44743 9.20327 9.44743C9.04883 9.44743 8.89439 9.3921 8.77657 9.28141C8.54091 9.06004 8.54091 8.70115 8.77657 8.47978L10.5624 6.8022H3.16904C2.83579 6.8022 2.56562 6.5484 2.56562 6.23535C2.56562 5.9223 2.83579 5.6685 3.16904 5.6685H10.5625L8.77657 3.99078C8.54091 3.76941 8.54095 3.41051 8.77657 3.18914Z",
    fill: "#505767"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.422301de87505d9464a9aec6dd6a4ede.svg";
export { ForwardRef as ReactComponent };